// @ts-strict-ignore
import {Component, Input, output, TemplateRef} from "@angular/core";
import {TrackByMethods} from "@services";
import {Translations} from "@translations";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {AssessablePanelMode} from "@common/components/assessment/utils";

type MultipleChoiceItem = {answer: any; options: string[]};

@Component({
	selector: "sim-multiple-choice-item",
	templateUrl: "./multiple-choice-item.component.html",
	styleUrls: ["./multiple-choice-item.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 250}), zoomOutOnLeaveAnimation({duration: 250})],
	standalone: false,
})
export class MultipleChoiceItemComponent {
	protected readonly TrackByMethods = TrackByMethods;
	protected readonly T = Translations;
	protected readonly AssessablePanelMode = AssessablePanelMode;

	@Input({required: true}) mode: AssessablePanelMode;
	@Input({required: true}) item: MultipleChoiceItem;
	@Input({required: true}) optionTemplate: TemplateRef<any>;
	@Input() scoreTemplate: TemplateRef<any>;
	@Input() rightOfAddOptionTemplate: TemplateRef<any>;
	@Input() inEditMode = false;

	onRemoveOption = output<number>();
	onAddOption = output<void>();
	onUpdateAnswerMultipleChoice = output<{
		index: number;
		checked: boolean;
	}>();

	handleCheckboxChange(index: number, checked: boolean) {
		if (this.mode === AssessablePanelMode.Answer) {
			this.onUpdateAnswerMultipleChoice.emit({
				index: index,
				checked: checked,
			});
		}
	}
}
